// Rail de herramientas. En desktop es una columna vertical a la izquierda
// (`orientation="side"`); en mobile una barra horizontal al pie del editor
// (`orientation="bottom"`), como el MobileBottomNav del shell de Atlas. Se renderiza
// dos veces desde EditorShell (una `hidden md:flex`, otra `md:hidden`), compartiendo
// active/onSelect. Cada tool abre su panel (bottom-sheet en mobile).

import type { LucideIcon } from 'lucide-react';

export interface Tool {
  id: string;
  label: string;
  icon: LucideIcon;
}

interface Props {
  tools: Tool[];
  active: string | null;
  onSelect: (id: string | null) => void;
  orientation: 'side' | 'bottom';
}

export function ToolRail({ tools, active, onSelect, orientation }: Props) {
  if (orientation === 'side') {
    return (
      <div className="hidden md:flex shrink-0 w-[68px] border-r border-neutral-200 bg-surface-card flex-col items-center py-2 gap-1 overflow-y-auto">
        {tools.map((t) => {
          const on = active === t.id;
          const Icon = t.icon;
          return (
            <button
              key={t.id}
              type="button"
              onClick={() => onSelect(on ? null : t.id)}
              className={`w-[58px] py-2 rounded-md flex flex-col items-center gap-1 text-[11px] font-medium transition active:scale-95 ${
                on ? 'bg-brand-primary/[0.08] text-brand-primary' : 'text-neutral-600 hover:bg-neutral-100'
              }`}
            >
              <Icon className="w-5 h-5" />
              <span>{t.label}</span>
            </button>
          );
        })}
      </div>
    );
  }

  // Mobile: barra horizontal al pie (parte del flex-col del shell, con safe-area).
  return (
    <div
      className="md:hidden shrink-0 border-t border-neutral-200 bg-surface-card flex items-stretch"
      style={{ paddingBottom: 'calc(env(safe-area-inset-bottom, 0px))' }}
    >
      {tools.map((t) => {
        const on = active === t.id;
        const Icon = t.icon;
        return (
          <button
            key={t.id}
            type="button"
            onClick={() => onSelect(on ? null : t.id)}
            // Alto/tamaños alineados al MobileBottomNav de Atlas (h-16, icono
            // ~24px, label 11px, centrado) para que no se vea más chica.
            className={`flex-1 h-16 flex flex-col items-center justify-center gap-1 text-[11px] font-medium leading-none transition active:opacity-60 ${
              on ? 'text-brand-primary' : 'text-neutral-600'
            }`}
          >
            <Icon className="w-6 h-6" />
            <span>{t.label}</span>
          </button>
        );
      })}
    </div>
  );
}
